import AnimatedSection from '../common/AnimatedSection'
import { achievementsSuccessIcons } from '../icons/AchievementsSectionIcons'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { achievementsSuccessFactorsSection } from '../../data/achievementsPageData'

function AchievementsSuccessFactorsSection() {
  const { label, titleLine1, titleAccent, factors } = achievementsSuccessFactorsSection

  return (
    <AnimatedSection className="achievements-success-factors">
      <div className="container corp-container">
        <header className="achievements-success-factors__head">
          <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
        </header>

        <div className="achievements-success-factors__grid" role="list">
          {factors.map((factor) => {
            const Icon = achievementsSuccessIcons[factor.icon]
            return (
              <article className="achievements-success-card" key={factor.id} role="listitem">
                <span className="achievements-success-card__icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{factor.title}</h3>
                <p>{factor.description}</p>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AchievementsSuccessFactorsSection
